import React from 'react';
import styled from 'styled-components';
import { INextStepType } from '../../../redux/slices/cachedEntities';
import { QueryType } from '../../../utils/apollo/graphqlSchema';
import { queryTypeConfigLookup } from '../../../utils/queryTypeLookup';
import { SvgIcon } from '../../Icon';
import { theme } from '../../../styles/theme';
import {
  level1Content,
  overflowingStyles,
} from '../../../styles/shareableStyles';

interface IProps {
  queryType: INextStepType;
  onClick: () => void;
}

const Container = styled.div`
  flex: 1;
  padding: 8px 12px;
  ${level1Content};
  color: ${theme.colors.secondary600};
  &:hover {
    border-color: ${theme.colors.mainBlue};
    color: ${theme.colors.mainBlue};
    cursor: pointer;
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`;

const Title = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
`;

const Description = styled.div`
  max-width: 100%;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  ${overflowingStyles};
`;

const nextStepDescriptions: Record<INextStepType, string> = {
  [QueryType.Expression]: 'Explore user segment behaviors',
  [QueryType.Funnel]: 'Analyze user steps towards a goal',
  [QueryType.Path]: 'Understand user product navigation',
  [QueryType.Retention]: 'Examine cohort retention over time',
  [QueryType.DataTable]: 'Unlock multi-dimensional analysis',
};

const NextStepItem = ({ queryType, onClick }: IProps) => {
  const { icon, display } = queryTypeConfigLookup[queryType];
  const description = nextStepDescriptions[queryType];

  return (
    <Container onClick={onClick}>
      <Header>
        <SvgIcon
          name={icon}
          width={16}
          height={16}
          customFill={theme.colors.mainBlue}
        />
        <Title>{display}</Title>
      </Header>
      <Description>{description}</Description>
    </Container>
  );
};

export default NextStepItem;
